module.exports = __webpack_public_path__ + "img/signin-3.2164fb5a.png";